import { render, staticRenderFns } from "./CreateIncident.vue?vue&type=template&id=3349b161&scoped=true&"
import script from "./CreateIncident.vue?vue&type=script&lang=ts&"
export * from "./CreateIncident.vue?vue&type=script&lang=ts&"
import style0 from "./CreateIncident.vue?vue&type=style&index=0&id=3349b161&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349b161",
  null
  
)

export default component.exports